import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import play from '../../img/ic_play.png'
import ModalMenu from '../../containers/ModalMenu';
import NewAlbum from '../../img/newPhoto.png'

import { Translate } from '../../language';
import { ReactComponent as OptionsIcon } from '../../img/ic_opciones.svg';
import { connect, useDispatch } from 'react-redux'
import { ReactComponent as DeleteIcon } from '../../img/ic_eliminar.svg';
import { ReactComponent as EditIcon } from '../../img/editar.svg';
import GifPlayer from 'react-gif-player'
import { getUserAlbums, deleteAlbum, clearAlbums, addAlbum } from '../../actions/userActions'
import inMemoryJWT from '../../auth/inMemoryJwt';
import CardList from '../../utils/components/CardList/CardList';
import { getCover } from './utils';
import { PlusIcon } from '../../assets/icons';
import Input from '../../utils/components/Input/Input';
import Button from '../../utils/components/Button/Button';

import localStorage from '../../utils/hooks/useLocalStorage';

const Albums = ({ history, match, userAlbums, isMyMark, clearAlbums, getUserAlbums, isLoadingAlbums,deleteAlbum }) => {

    const [isShowModal, setIsShowModal] = useState(false)
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getUserAlbums(match.params.userID)
        })
        return () => {
            clearAlbums()
        }

    }, [])

    const [isLoadContent, setIsLoadContent] = useState(false)
    const onloadcontent = () => {
        setIsLoadContent(true)
    }




    if (isLoadingAlbums)
        return <div>cargando...</div>
    else {
        return (
            <div className='content-list-social scroll-menu'>

                {userAlbums.map((album) =>
                    <>
                        {console.log()}
                        {album?.newpost === true ?
                            <div key={0} className="content-card-list content-card-list-plus" onClick={(e) => {
                                e.stopPropagation();
                                setIsShowModal(true)
                            }}>

                                <PlusIcon className="icon-new-story" />

                            </div> :
                            <CardList
                                options={[

                                    (
                                        match.params.userID === localStorage().getItem("idUser")) && {
                                        text: Translate('delete', 'es'), onClick: (e) => {
                                            deleteAlbum(album._id)
                                            e.preventDefault(); e.stopPropagation();
                                        }

                                    }
                                ]}
                                picture={getCover(album.coverAlbum)}
                                textOne={album.name}
                                textTwo=''
                                key={album._id}
                                onClick={
                                    (e) => {
                                        e.stopPropagation()
                                        history.push("/Profile/" + match.params.userID + '/Album/' + album._id)
                                    }
                                }
                            />

                        }

                    </>
                )}
                <Modal displayModal={isShowModal} closeModal={() => setIsShowModal(false)} />
            </div>
        )
    }
}

const Modal = ({ displayModal }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const [privacy, setPrivacy] = useState(0)
    const [valid, setValid] = useState(true)
    const [name, setName] = useState("")
    return (
        <div className='modal' style={divStyle}>
            <div className='modal-content'>
                <div>
                    <Input value={name} onChange={(e) => {
                        setName(e.target.value)
                        if (e.target.value.length > 0) {
                            setValid(true)
                        } else {
                            setValid(false)
                        }

                    }} error={valid ? "" : "Escriba el nombre"} />

                </div>


                <div className='parent-width column spaceAround'>
                    <Button text={Translate('public', 'es')} active={privacy === 0} onClick={() => { setPrivacy(0) }} />
                    <Button text={Translate('myPrivate', 'es')} active={privacy === 1} onClick={() => { setPrivacy(1) }} />

                </div>
                <Button text='Crear' onClick={() => {
                    if (name.length > 0) {
                        console.log();
                        dispatch(addAlbum({
                            name, privacy
                        }, history))
                    }

                }} />

            </div>

        </div>
    )
}
const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        userAlbums: state.userInfo.userAlbums,
        isLoadingAlbums: state.userInfo.isLoadingGetUserAlbums
    }
}

export default connect(mapStateToProps, { getUserAlbums, clearAlbums, addAlbum, deleteAlbum })(Albums)


